import { useQuery } from '@tanstack/react-query';

import { Button } from '@/shared/ui/button';

import { submissionFilesQuery } from '../api/submission-files';
import { needsReviewReferenceFiles, presentWorkshopReview } from '../review-presentation';

import { WorkshopFeedback } from './workshop-feedback';

import type { WorkshopEvaluation } from '@mio/shared';

interface Props {
  submissionId: string;
  explanation: string;
  result: WorkshopEvaluation;
}

function FeedbackWithReferences({ submissionId, explanation, result }: Props) {
  const files = useQuery(submissionFilesQuery(submissionId));
  return (
    <>
      <WorkshopFeedback result={presentWorkshopReview(result, files.data, explanation)} />
      {files.error ? (
        <div className="text-fg-muted mt-3 space-y-2 text-xs">
          <p>
            Some file references could not be loaded. Your feedback and saved excerpts are shown.
          </p>
          <Button
            variant="secondary"
            loading={files.isFetching}
            loadingLabel="Loading file references…"
            onClick={() => void files.refetch()}
          >
            Retry file references
          </Button>
        </div>
      ) : null}
    </>
  );
}

export function SubmissionFeedback(props: Props) {
  return needsReviewReferenceFiles(props.result) ? (
    <FeedbackWithReferences {...props} />
  ) : (
    <WorkshopFeedback result={presentWorkshopReview(props.result, undefined, props.explanation)} />
  );
}
